import { useNavigate } from '@tanstack/react-router';
import { type ReactNode, useEffect } from 'react';
import { useAuth } from '@/providers/auth-provider';

interface ProtectedRouteProps {
  children: ReactNode;
}

export function ProtectedRoute({ children }: ProtectedRouteProps) {
  const { status, session } = useAuth();
  const navigate = useNavigate();

  useEffect(() => {
    if (status === 'unauthenticated') {
      navigate({ to: '/login' });
    }
  }, [status, navigate]);

  if (status === 'loading') {
    return (
      <div className="min-h-screen flex items-center justify-center">
        <div className="animate-spin rounded-full h-8 w-8 border-b-2 border-blue-600"></div>
      </div>
    );
  }

  if (status === 'unauthenticated' || !session) {
    return null; // Will redirect to login
  }

  return <>{children}</>;
}
